/**
 * Re-sync document body scroll lock after a modal closes.
 * Nested reactstrap modals can strip `modal-open` from <body> while another
 * modal is still open. Call only from close handlers — not on open or during saves.
 *
 * Only touches <body>. In-modal scrolling is handled by CSS (.modal.show).
 */
let cleanupTimer = null;

function openModalCount() {
	return document.querySelectorAll('.modal.show').length;
}

export default function syncBodyScrollLock() {
	if (cleanupTimer) {
		clearTimeout(cleanupTimer);
		cleanupTimer = null;
	}

	const restoreIfNeeded = () => {
		if (openModalCount() > 0) {
			document.body.classList.add('modal-open');
		}
	};

	window.requestAnimationFrame(() => {
		window.requestAnimationFrame(restoreIfNeeded);
	});

	// Wait for reactstrap fade-out before clearing body lock (avoids false negatives mid-transition).
	cleanupTimer = window.setTimeout(() => {
		cleanupTimer = null;
		if (openModalCount() > 0) {
			document.body.classList.add('modal-open');
			return;
		}
		document.body.classList.remove('modal-open');
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
	}, 350);
}
